import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { getMatchReasons } from '../common/Validations';

const ClientDuplicateModal = ({ show, duplicates, onConfirm, onMerge, onClose }) => {
  if (!show) return null;

  const handleMerge = (duplicate, e) => {
    e.preventDefault();
    if (onMerge) {
      onMerge(duplicate);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Uwaga - wykryto duplikaty</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Wykryto {duplicates.length} potencjalnych
          {duplicates.length === 1 ? ' duplikat' : ' duplikaty'}:
        </p>
        <ul>
          {duplicates.map((duplicate) => {
            const reasons = getMatchReasons(duplicate);
            const reasonsText = reasons.join(', ');

            return (
              <li key={duplicate.id}>
                <strong>{duplicate.firstName} {duplicate.lastName}</strong>
                {` (ID: ${duplicate.id})`}
                {reasonsText && ` - dopasowanie: ${reasonsText}`}
                {onMerge && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary ms-2"
                    onClick={(e) => handleMerge(duplicate, e)}
                  >
                    Scal
                  </button>
                )}
              </li>
            );
          })}
        </ul>
        <p className="mb-0">Czy na pewno chcesz utworzyć nowego klienta?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <Button variant="warning" onClick={onConfirm}>
          Tak, utwórz mimo to
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ClientDuplicateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  duplicates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      matchReasons: PropTypes.arrayOf(PropTypes.string),
      matchReason: PropTypes.string, // Legacy format support
    })
  ).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onMerge: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

ClientDuplicateModal.defaultProps = {
  onMerge: null,
};

export default ClientDuplicateModal;
